const quickTags = [
  { href: "#creators", label: "头部大V" },
  { href: "#creators", label: "优质达人" },
  { href: "#rising", label: "潜力新人" },
  { href: "#categories", label: "按领域找" },
  { href: "#ranking", label: "精选榜" },
];

const heroStats = [
  { value: "18+", label: "创作者速览档案" },
  { value: "8 大", label: "常青内容领域" },
  { value: "3 类", label: "创作者梯队" },
  { value: "1 页", label: "生态全景速览" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20organic%20shapes%20in%20deep%20forest%20green%20and%20warm%20amber%20gradient%2C%20soft%20grain%20texture%2C%20editorial%20minimal%20background%2C%20no%20text%2C%20cinematic%20lighting&width=1600&height=900&seq=xigua-hero-bg-2026&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-32 pb-16 md:pt-44 md:pb-24">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs md:text-sm font-medium text-background-50 backdrop-blur">
            <i className="ri-live-line"></i>
            西瓜视频创作者生态速览
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl md:leading-[1.15]">
            西瓜视频网红都有谁？
            <span className="mt-3 block text-xl font-bold text-accent-300 md:text-3xl">
              头部创作者、主播名单、大V与达人一页速览
            </span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            这里整理西瓜视频上活跃的内容生产者与主播信息，覆盖头部大V、优质达人与潜力创作者。
            想了解平台生态、找对口味博主，还是想追踪当下的热门网红，都可以从这一页开始，
            一眼锁定值得关注的人。
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <a
              href="#creators"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-list-check-3"></i>
              浏览创作者名单
            </a>
            <a
              href="#guide"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-compass-3-line"></i>
              怎么挑到合适的人
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-2.5">
            {quickTags.map((tag) => (
              <a
                key={tag.label}
                href={tag.href}
                className="whitespace-nowrap rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium text-background-100 backdrop-blur transition-colors hover:bg-background-50/20"
              >
                {tag.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-50/20 bg-background-50/10 px-4 py-4 text-center backdrop-blur"
            >
              <p className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-background-100 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}